/**
 * 土地测评
 */
class DZModelEvaluate{
    
    /**
     * 土地信息ID
     */
    landId = "";

    /**
     * 区位优势评价：1-极差，2-差，3-一般，4-良，5-优良
     */
    locationAdvantage = 0;

    /**
     * 区位优势评价描述
     */
    locationAdvantageDesc = "";

    /**
     * 气候条件评价：1-极差，2-差，3-一般，4-良，5-优良
     */
    climateCondition = 0;

    /**
     * 气候条件评价描述
     */
    climateConditionDesc = "";

    /**
     * 相关配套评价：1-极差，2-差，3-一般，4-良，5-优良
     */
    supportingFacilities = 0;

    /**
     * 相关配套评价描述
     */
    supportingFacilitiesDesc = "";

    /**
     * 地块情况评价：1-极差，2-差，3-一般，4-良，5-优良
     */
    plotSituation = 0;

    /**
     * 地块情况评价描述
     */
    plotSituationDesc = "";

    /**
     * 经营现状评价：1-极差，2-差，3-一般，4-良，5-优良
     */
    businessStatus = 0;

    /**
     * 经营现状评价描述
     */
    businessStatusDesc = "";

    /**
     * 土地经营建议
     */
    businessAdvice = "";

    /**
     * 土地用途
     */
    landUse = "";

    /**
     * 适合经营
     */
    suitableBusiness = "";
}
export default DZModelEvaluate